module.exports = __webpack_public_path__ + "assets/img/1007-bz.svg";